import { SortDictionary } from "types/business/SortDictionary";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = SortDictionary;

export const useDefaultObservableSortDictionary = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectSortDictionary extends BehaviorSubject<CurrentType> {}
